module.exports = __webpack_public_path__ + "img/banker-gold_600.a42b19f7.png";